/* ZSportsTech — section-quote.js
   Scoped to #sc-brquote (Bat Repair · 02 quote builder).
   Live estimate, qty steppers, tab filter.
   Maps to → assets/section-quote.js in Shopify theme.
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  var root = document.getElementById('sc-brquote');
  if (!root) return;

  var rows       = Array.prototype.slice.call(root.querySelectorAll('.service-row'));
  var linesEl    = root.querySelector('[data-brquote-lines]');
  var emptyEl    = root.querySelector('[data-brquote-empty]');
  var railHead   = root.querySelector('[data-brquote-railhead]');
  var totalEls   = root.querySelectorAll('[data-brquote-total]');

  /* ── Helpers ───────────────────────────────────── */
  function fmt(n) { return '₹' + n.toLocaleString('en-IN'); }
  function isSelected(row) { return row.getAttribute('data-selected') === 'true'; }
  function qtyOf(row) { return parseInt(row.getAttribute('data-qty') || '1', 10); }
  function priceOf(row) { return parseInt(row.getAttribute('data-price') || '0', 10); }

  function lineFor(row) {
    var name = row.getAttribute('data-name');
    var type = row.getAttribute('data-type');
    var qty  = qtyOf(row);
    var amt  = priceOf(row) * (type === 'stepper' ? qty : 1);
    var label = (type === 'stepper' && qty > 1) ? (name + ' ×' + qty) : name;
    return { label: label, amt: amt };
  }

  /* ── Repair SKU binding ─────────────────────────────
     window.SC_REPAIR_SKUS is emitted by the Liquid section from the
     repair-services / repair-addons collections, keyed by data-svc. A row
     whose key isn't present (the product was pulled from the collection in
     admin) is hidden and dropped from every list/loop below. A row whose
     product carries >1 variant becomes a "picker" row: the customer must
     choose the exact variant before it can be added. ─────────────────── */
  var SKUS = window.SC_REPAIR_SKUS || {};
  var origNames = {};
  var productCache = {};

  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  rows = rows.filter(function (row) {
    var svc = row.getAttribute('data-svc');
    var sku = SKUS[svc];
    if (!sku) {
      row.hidden = true;
      return false;
    }
    origNames[svc] = row.getAttribute('data-name');
    if (sku.count > 1) {
      row.setAttribute('data-picker', 'true');
      row.setAttribute('data-handle', sku.handle);
      row.setAttribute('data-variant-id', '');
      row.setAttribute('data-price', '0');
      var metaEl = row.querySelector('.service-row__meta');
      if (metaEl) metaEl.textContent = 'from ' + fmt(sku.priceMin);
    } else {
      row.setAttribute('data-variant-id', String(sku.id));
      row.setAttribute('data-price', String(sku.price));
    }
    return true;
  });

  /* Deselecting a picker row clears the pick entirely — there's no "edit"
     affordance, the customer starts over from "from ₹X". */
  function clearPick(row) {
    var svc = row.getAttribute('data-svc');
    var sku = SKUS[svc];
    row.setAttribute('data-variant-id', '');
    row.setAttribute('data-price', '0');
    row.setAttribute('data-name', origNames[svc]);
    row.picks = [];
    var metaEl = row.querySelector('.service-row__meta');
    if (metaEl && sku) metaEl.textContent = 'from ' + fmt(sku.priceMin);
  }

  /* ── Picker rows: MULTIPLE picks ───────────────────────────────────
     A picker row (Bat Grips today) can hold several DISTINCT variants at
     once — Black/Red AND a Kids grip are two separate cart lines. row.picks
     holds the live pick objects for that base row; each pick renders as its
     own .service-row inserted directly beneath the base row, reusing the
     existing row markup/classes so it looks native. ─────────────────── */
  var THUMB_ICON = '<svg class="service-row__thumb-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg>';

  var openPromptEl = null;   /* the currently-open pick-row prompt, or null */
  var openPromptPick = null; /* the pick it belongs to — only one open at a time */

  function closePrompt() {
    if (openPromptEl && openPromptEl.parentNode) openPromptEl.parentNode.removeChild(openPromptEl);
    openPromptEl = null;
    openPromptPick = null;
  }

  document.addEventListener('click', function (e) {
    if (!openPromptEl) return;
    if (openPromptEl.contains(e.target)) return;
    if (e.target.closest && e.target.closest('[data-pick-plus]')) return; /* the + button toggles itself */
    closePrompt();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPromptEl) closePrompt();
  });

  function findPick(row, variantId) {
    var picks = row.picks || [];
    for (var i = 0; i < picks.length; i++) {
      if (String(picks[i].variantId) === String(variantId)) return picks[i];
    }
    return null;
  }

  function renderPick(pick) {
    pick.nameEl.textContent = pick.name;
    pick.metaEl.textContent = fmt(pick.price);
    pick.qtyEl.textContent = String(pick.qty);
  }

  function openPickPrompt(row, pick) {
    var ctrl = pick.el.querySelector('.service-row__ctrl');
    var prompt = document.createElement('div');
    prompt.className = 'sc-brquote__pickprompt';
    prompt.setAttribute('role', 'menu');
    prompt.innerHTML =
      '<button type="button" class="sc-brquote__pickprompt-opt" data-pickprompt-same></button>' +
      '<button type="button" class="sc-brquote__pickprompt-opt" data-pickprompt-diff>A different grip</button>';
    prompt.querySelector('[data-pickprompt-same]').textContent = 'Another ' + pick.title;
    prompt.querySelector('[data-pickprompt-same]').addEventListener('click', function () {
      closePrompt();
      pick.qty += 1;
      renderPick(pick);
      recompute();
    });
    prompt.querySelector('[data-pickprompt-diff]').addEventListener('click', function () {
      closePrompt();
      window.SCVariantPicker.open(row.getAttribute('data-handle'), function (variantId) {
        if (!variantId) return; /* cancelled */
        fetchProduct(row.getAttribute('data-handle')).then(function (data) {
          addOrIncPick(row, variantId, data);
        });
      });
    });
    ctrl.appendChild(prompt);
    openPromptEl = prompt;
    openPromptPick = pick;
  }

  function removePick(row, pick) {
    closePrompt();
    var picks = row.picks || [];
    var idx = picks.indexOf(pick);
    if (idx !== -1) picks.splice(idx, 1);
    if (pick.el && pick.el.parentNode) pick.el.parentNode.removeChild(pick.el);
    if (!picks.length) {
      row.setAttribute('data-selected', 'false');
      clearPick(row);
    }
    syncControl(row);
    recompute();
  }

  function buildPickRow(row, pick) {
    var svc = row.getAttribute('data-svc');
    var el = document.createElement('div');
    el.className = 'service-row';
    el.setAttribute('data-pick-row', 'true');
    el.setAttribute('data-svc', svc);
    el.setAttribute('data-type', 'stepper');
    el.setAttribute('data-selected', 'true');
    el.innerHTML =
      '<div class="service-row__thumb">' + THUMB_ICON + '</div>' +
      '<div class="service-row__main">' +
        '<div class="service-row__name-line"><span class="service-row__name"></span></div>' +
        '<p class="service-row__meta"></p>' +
      '</div>' +
      '<div class="service-row__ctrl">' +
        '<div class="service-row__stepper" role="group" aria-label="Quantity">' +
          '<button class="service-row__step" type="button" data-pick-step="-1" aria-label="Decrease quantity">−</button>' +
          '<span class="service-row__qty"></span>' +
          '<button class="service-row__step" type="button" data-pick-step="1" aria-label="Increase quantity" data-pick-plus>+</button>' +
        '</div>' +
        '<button class="service-row__btn service-row__rm" type="button" data-pick-remove aria-label="Remove">✕</button>' +
      '</div>';

    pick.el = el;
    pick.nameEl = el.querySelector('.service-row__name');
    pick.metaEl = el.querySelector('.service-row__meta');
    pick.qtyEl = el.querySelector('.service-row__qty');
    pick.plusBtn = el.querySelector('[data-pick-plus]');

    el.querySelector('[data-pick-step="-1"]').addEventListener('click', function () {
      closePrompt();
      pick.qty -= 1;
      if (pick.qty <= 0) { removePick(row, pick); return; }
      renderPick(pick);
      recompute();
    });

    /* Pressing + must PROMPT — not silently increment — so a mobile thumb
       already on this row can choose "another one of these" vs. "a
       different grip" without leaving the add-ons list. */
    pick.plusBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var already = (openPromptPick === pick);
      closePrompt();
      if (already) return; /* clicking + again closes it */
      openPickPrompt(row, pick);
    });

    el.querySelector('[data-pick-remove]').addEventListener('click', function () {
      removePick(row, pick);
    });

    renderPick(pick);
    return el;
  }

  function addOrIncPick(row, variantId, data) {
    var svc = row.getAttribute('data-svc');
    var existing = findPick(row, variantId);
    if (existing) {
      existing.qty += 1;
      renderPick(existing);
      recompute();
      return;
    }
    var variant = data && data.variants ? data.variants.filter(function (v) { return v.id === variantId; })[0] : null;
    var price = variant ? Math.round(variant.price / 100) : 0;
    var title = variant ? variant.title : '';
    var pick = { variantId: variantId, title: title, price: price, qty: 1, name: origNames[svc] + ' · ' + title };
    if (!row.picks) row.picks = [];
    row.picks.push(pick);
    var el = buildPickRow(row, pick);
    var prevEl = row.picks.length > 1 ? row.picks[row.picks.length - 2].el : row;
    prevEl.parentNode.insertBefore(el, prevEl.nextSibling);
    row.setAttribute('data-selected', 'true');
    syncControl(row);
    recompute();
  }

  /* ── Reflect a row's state onto its control ───── */
  function syncControl(row) {
    var sel = isSelected(row);
    var btn = row.querySelector('[data-brquote-toggle]');
    if (btn) {
      btn.classList.toggle('is-added', sel);
      var add   = btn.getAttribute('data-label-add');
      var added = btn.getAttribute('data-label-added');
      if (added) { btn.textContent = sel ? added : add; }
      else if (add) { btn.textContent = add; } /* price-type keeps its label */
    }
  }

  /* ── Shopify cart sync ─────────────────────────────
     The quote IS the cart: every change writes absolute quantities for all
     service variants via /cart/update.js, so the nav drawer and checkout
     always match the builder. Chained so rapid taps can't land out of order. */
  var syncTimer = null;
  var syncChain = Promise.resolve();
  var hydrated = false;
  function cartUpdates() {
    var updates = {};
    rows.forEach(function (row) {
      var svc = row.getAttribute('data-svc');
      var sku = SKUS[svc];

      /* Picker rows can hold SEVERAL distinct picks (Black/Red AND a Kids
         grip, say) — every known variant id of the product must be emitted:
         zero for anything not currently picked, or an abandoned pick stays
         in the cart and the customer is charged for it. */
      if (row.getAttribute('data-picker') === 'true') {
        if (sku && sku.ids && sku.ids.length) {
          sku.ids.forEach(function (id) { updates[id] = 0; });
        }
        (row.picks || []).forEach(function (p) { updates[p.variantId] = p.qty; });
        return;
      }

      var selVid = row.getAttribute('data-variant-id');
      var qty = isSelected(row) ? qtyOf(row) : 0;
      /* A row can have picked (and abandoned) more than one of its product's
         variants across the session — e.g. Black/Red, then deselected, then
         Green/White. Every known variant id must be zeroed except the one
         currently selected, or the abandoned one stays in the cart and the
         customer is charged for both. */
      if (sku && sku.ids && sku.ids.length) {
        sku.ids.forEach(function (id) {
          updates[id] = (selVid && String(id) === String(selVid)) ? qty : 0;
        });
      } else if (selVid) {
        updates[selVid] = qty;
      }
    });
    return updates;
  }
  function pushCart() {
    syncChain = syncChain.then(function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: cartUpdates() })
      }).then(function (r) { return r.json(); }).then(function () {
        if (window.SCCart) window.SCCart.refresh();
      }).catch(function () {});
    });
    return syncChain;
  }
  function scheduleSync() {
    if (!hydrated) return;
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(pushCart, 350);
  }

  /* ── Recompute estimate + render ───────────────── */
  function recompute() {
    var items = [];
    rows.forEach(function (row) {
      /* Picker rows contribute ONE quote line per pick, so the rail and the
         cart agree line for line — a single aggregate line would hide which
         variants are actually in the cart. */
      if (row.getAttribute('data-picker') === 'true') {
        (row.picks || []).forEach(function (p) {
          var label = (p.qty > 1) ? (p.name + ' ×' + p.qty) : p.name;
          items.push({ label: label, amt: p.price * p.qty });
        });
        return;
      }
      if (isSelected(row)) items.push(lineFor(row));
    });

    var total = items.reduce(function (s, it) { return s + it.amt; }, 0);

    /* Rail line items */
    if (linesEl) {
      linesEl.innerHTML = '';
      items.forEach(function (it) {
        var line = document.createElement('div');
        line.className = 'sc-brquote__line';
        line.innerHTML = '<span class="sc-brquote__line-name"></span><span class="sc-brquote__line-amt"></span>';
        line.querySelector('.sc-brquote__line-name').textContent = it.label;
        line.querySelector('.sc-brquote__line-amt').textContent = fmt(it.amt);
        linesEl.appendChild(line);
      });
    }
    if (emptyEl) emptyEl.style.display = items.length ? 'none' : 'block';
    if (railHead) railHead.textContent = 'Your quote · ' + items.length + (items.length === 1 ? ' item' : ' items');
    totalEls.forEach(function (el) { el.textContent = fmt(total); });

    scheduleSync();
  }

  /* ── Wire controls ─────────────────────────────── */
  rows.forEach(function (row) {
    var type = row.getAttribute('data-type');

    /* Toggle buttons (add / price / addon) */
    var toggle = row.querySelector('[data-brquote-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var willSelect = !isSelected(row);

        /* Picker rows (>1 variant, e.g. Bat Grips) can't just be toggled on —
           the customer must choose the exact variant first. */
        if (row.getAttribute('data-picker') === 'true' && willSelect) {
          window.SCVariantPicker.open(row.getAttribute('data-handle'), function (variantId) {
            if (!variantId) return; /* cancelled — row stays unselected */
            fetchProduct(row.getAttribute('data-handle')).then(function (data) {
              addOrIncPick(row, variantId, data);
            });
          });
          return;
        }

        var sel = willSelect;
        row.setAttribute('data-selected', sel ? 'true' : 'false');
        /* stepper rows start at qty 1 when added via the Add button */
        if (type === 'stepper') {
          var q = sel ? 1 : 0;
          row.setAttribute('data-qty', String(q));
          var qEl = row.querySelector('[data-brquote-qty]');
          if (qEl) qEl.textContent = String(q);
        }

        if (row.getAttribute('data-picker') === 'true' && !sel) clearPick(row);

        syncControl(row);
        recompute();
      });
    }

    /* Stepper */
    if (type === 'stepper') {
      var qtyEl = row.querySelector('[data-brquote-qty]');
      row.querySelectorAll('[data-brquote-step]').forEach(function (step) {
        step.addEventListener('click', function () {
          var delta = parseInt(step.getAttribute('data-brquote-step'), 10);
          var q = Math.max(0, qtyOf(row) + delta);
          row.setAttribute('data-qty', String(q));
          row.setAttribute('data-selected', q > 0 ? 'true' : 'false');
          if (qtyEl) qtyEl.textContent = String(q);
          if (row.getAttribute('data-picker') === 'true' && q === 0) clearPick(row);
          syncControl(row); /* stepping to 0 must reset the button to "Add" */
          recompute();
        });
      });
    }

    /* "how we do it" expander */
    var how = row.querySelector('[data-brquote-how]');
    var howBody = row.querySelector('.service-row__how-body');
    if (how && howBody) {
      var toggleHow = function () {
        var open = howBody.classList.toggle('is-open');
        how.textContent = open ? 'how we do it ▴' : 'how we do it ▾';
      };
      how.addEventListener('click', toggleHow);
      how.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleHow(); }
      });
    }
  });

  /* ── Tabs ──────────────────────────────────────── */
  var tabs = root.querySelectorAll('[data-brquote-tab]');
  var groups = root.querySelectorAll('[data-brquote-group]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var which = tab.getAttribute('data-brquote-tab');
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('sc-brquote__tab--active', on);
        t.setAttribute('aria-selected', String(on));
      });
      groups.forEach(function (g) {
        var grp = g.getAttribute('data-brquote-group');
        g.style.display = (which === 'all' || which === grp) ? '' : 'none';
      });
    });
  });

  /* ── Continue → flush the cart sync, then straight to checkout ──
     The cart already mirrors the quote; this just makes sure the last
     change has landed before leaving the page. */
  function goCheckout(btn) {
    if (!rows.some(isSelected)) return;
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Preparing…';
    window.clearTimeout(syncTimer);
    pushCart().then(function () {
      window.location.href = '/checkout';
    }).catch(function () {
      btn.removeAttribute('aria-busy');
      btn.textContent = label;
      if (window.SCCart) window.SCCart.open();
    });
  }
  root.querySelectorAll('[data-brquote-checkout]').forEach(function (btn) {
    btn.addEventListener('click', function () { goCheckout(btn); });
  });

  /* ── "How it works" modal ───────────────────────────
     Content lives in <template data-brhow-tpl="..."> blocks in the section.
     Media falls back in order: data-video (a YouTube id) → data-image (the
     service's product photo) → a "coming soon" panel. */
  var howModal = root.querySelector('#sc-brhow');
  if (howModal) {
    var howMedia = howModal.querySelector('[data-brhow-media]');
    var howTitle = howModal.querySelector('[data-brhow-title]');
    var howBody  = howModal.querySelector('[data-brhow-body]');
    var howLastFocus = null;

    var openHow = function (key) {
      var tpl = root.querySelector('template[data-brhow-tpl="' + key + '"]');
      if (!tpl) return;
      howTitle.textContent = tpl.getAttribute('data-title') || '';
      var vid = tpl.getAttribute('data-video');
      howMedia.innerHTML = '';
      if (vid) {
        var ifr = document.createElement('iframe');
        ifr.src = 'https://www.youtube-nocookie.com/embed/' + vid + '?rel=0';
        ifr.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        ifr.setAttribute('allowfullscreen', '');
        ifr.setAttribute('title', howTitle.textContent + ' · how we do it');
        howMedia.appendChild(ifr);
      } else if (tpl.getAttribute('data-image')) {
        /* No film of this one yet — show the service's own product photo. */
        var img = document.createElement('img');
        img.className = 'sc-brhow__img';
        img.src = tpl.getAttribute('data-image');
        img.alt = howTitle.textContent;
        img.loading = 'lazy';
        howMedia.appendChild(img);
      } else {
        var ph = document.createElement('div');
        ph.className = 'sc-brhow__ph';
        ph.textContent = 'Process photos coming soon';
        howMedia.appendChild(ph);
      }
      howBody.innerHTML = '';
      howBody.appendChild(tpl.content.cloneNode(true));
      howModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      howLastFocus = document.activeElement;
      howModal.querySelector('.sc-brhow__close').focus();
    };

    var closeHow = function () {
      if (!howModal.classList.contains('is-open') || howModal.classList.contains('is-closing')) return;
      howModal.classList.add('is-closing');
      window.setTimeout(function () {
        howModal.classList.remove('is-open');
        howModal.classList.remove('is-closing');
        howMedia.innerHTML = ''; /* removing the iframe stops playback */
        document.body.style.overflow = '';
        if (howLastFocus && howLastFocus.focus) howLastFocus.focus();
      }, 180);
    };

    root.querySelectorAll('[data-brhow]').forEach(function (btn) {
      btn.addEventListener('click', function () { openHow(btn.getAttribute('data-brhow')); });
    });
    howModal.querySelectorAll('[data-brhow-close]').forEach(function (btn) {
      btn.addEventListener('click', closeHow);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && howModal.classList.contains('is-open')) closeHow();
    });
  }

  /* Initial render: hydrate the builder from whatever repair services are
     already in the Shopify cart, then keep the two in lockstep. */
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      rows.forEach(function (row) {
        var svc = row.getAttribute('data-svc');
        var sku = SKUS[svc];
        var ids = (sku && sku.ids) || [];

        /* Picker rows must come back exactly as picked — EVERY cart line
           whose id is one of the product's variants becomes its own pick
           row (variant id, title, price, qty), not just the first one. */
        if (row.getAttribute('data-picker') === 'true') {
          var lines = cart.items.filter(function (it) { return ids.indexOf(it.id) !== -1; });
          if (!lines.length) return;
          row.picks = [];
          lines.forEach(function (line) {
            var price = Math.round(line.price / 100);
            var pick = {
              variantId: line.id,
              title: line.variant_title || '',
              price: price,
              qty: line.quantity,
              name: origNames[svc] + ' · ' + (line.variant_title || '')
            };
            row.picks.push(pick);
            var el = buildPickRow(row, pick);
            var prevEl = row.picks.length > 1 ? row.picks[row.picks.length - 2].el : row;
            prevEl.parentNode.insertBefore(el, prevEl.nextSibling);
          });
          row.setAttribute('data-selected', 'true');
          syncControl(row);
          return;
        }

        var line = cart.items.filter(function (it) { return ids.indexOf(it.id) !== -1; })[0];
        if (!line) return;
        row.setAttribute('data-selected', 'true');
        if (row.getAttribute('data-type') === 'stepper') {
          row.setAttribute('data-qty', String(line.quantity));
          var qEl = row.querySelector('[data-brquote-qty]');
          if (qEl) qEl.textContent = String(line.quantity);
        }
        syncControl(row);
      });
    })
    .catch(function () {})
    .then(function () {
      hydrated = true;
      recompute();
    });
}());
